import { client } from './setup';
import { EXTRA_FIELDS_API } from '../globals';

export default {
    getExtraFields: (params) => client.get(EXTRA_FIELDS_API, { params }),
    getExtraField: (id) => client.get(`${EXTRA_FIELDS_API}/${id}`),
    createExtraField: (field) => client.post(EXTRA_FIELDS_API, field),
    updateExtraField: (field) => client.put(`${EXTRA_FIELDS_API}/${field.id}`, field),
    deleteExtraField: (id, params) => client.delete(`${EXTRA_FIELDS_API}/${id}`, { params }),
}